import Reveal from "../components/Reveal";
import { teamData } from "../data";

const Team = () => {
  return (
    <main className="bg-[var(--bg)] text-[var(--bone)] pt-32 pb-24">
      {/* HERO */}
      <section className="px-5 md:px-10">
        <div className="max-w-7xl mx-auto grid grid-cols-12 gap-6">
          <div className="col-span-12 md:col-span-3">
            <Reveal>
              <div className="text-[10px] uppercase tracking-[0.32em] text-[var(--clay)]">
                — The team
              </div>
              <div className="mt-3 font-display text-5xl md:text-7xl text-[var(--bone)]">
                {String(teamData.length).padStart(2, "0")}
              </div>
            </Reveal>
          </div>
          <div className="col-span-12 md:col-span-9">
            <Reveal delay={120}>
              <h1 className="font-display font-light text-[clamp(2.5rem,6.5vw,6rem)] leading-[1] tracking-tight">
                A small team, a{" "}
                <span className="italic font-extralight">slow</span> hand,{" "}
                <span className="text-[var(--clay)]">seven</span> artists.
              </h1>
            </Reveal>
            <Reveal delay={240}>
              <p className="mt-10 max-w-2xl text-[var(--muted)] text-[17px] leading-relaxed">
                TABA is built by a tight crew of working artists — base kings,
                stroke masters, colour realists, all-rounders. The hands you
                see on every wall.
              </p>
            </Reveal>
          </div>
        </div>
      </section>

      {/* TEAM GRID */}
      <section className="px-5 md:px-10 mt-24 md:mt-32">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-12 gap-6 mb-12">
            <div className="col-span-12 md:col-span-9">
              <Reveal>
                <h2 className="font-display font-light text-[clamp(2.5rem,5vw,4rem)] leading-[1.05] tracking-tight">
                  Meet the <span className="italic font-extralight">hands</span>{" "}
                  behind the walls.
                </h2>
              </Reveal>
            </div>
          </div>

          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-6">
            {teamData.map((member, i) => (
              <Reveal key={member.id} delay={(i % 6) * 60}>
                <div className="group block relative overflow-hidden bg-[var(--bg-elevated)] editorial-frame">
                  <div className="aspect-[3/4] overflow-hidden">
                    <img
                      src={member.img}
                      alt={member.name}
                      loading="lazy"
                      className="w-full h-full object-cover grayscale group-hover:grayscale-0 transition-all duration-1000 group-hover:scale-105"
                    />
                  </div>
                  <div className="absolute inset-0 bg-gradient-to-t from-[var(--ink)] via-transparent to-transparent" />

                  <div className="absolute top-4 left-4 text-[10px] uppercase tracking-[0.32em] text-[var(--bone)]/80 flex items-center gap-2">
                    <span className="font-display text-lg text-[var(--clay)] leading-none tabular-nums">
                      0{i + 1}
                    </span>
                  </div>

                  <div className="absolute left-0 right-0 bottom-0 p-4 md:p-6">
                    <h3 className="font-display text-xl md:text-2xl text-[var(--bone)] leading-tight">
                      {member.name}
                    </h3>
                    <div className="mt-1 text-[10px] uppercase tracking-[0.32em] text-[var(--clay-light)]">
                      {member.title}
                    </div>
                  </div>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      {/* JOIN */}
      <section className="px-5 md:px-10 mt-24 md:mt-40">
        <div className="max-w-7xl mx-auto editorial-frame bg-[var(--bg-soft)] p-10 md:p-20">
          <Reveal>
            <div className="grid grid-cols-12 gap-6">
              <div className="col-span-12 md:col-span-7">
                <div className="text-[10px] uppercase tracking-[0.32em] text-[var(--clay)] mb-6">
                  — On the wall with us
                </div>
                <h2 className="font-display font-light text-[clamp(2rem,4.5vw,4rem)] leading-[1.05] tracking-tight">
                  We're slowly growing the{" "}
                  <span className="italic font-extralight">crew</span>.
                </h2>
                <p className="mt-6 text-[var(--muted)] text-[15px] leading-relaxed max-w-md">
                  If you're a working artist based in Delhi NCR who wants to
                  paint walls — not just make art for them — send us a few
                  pictures and a few words.
                </p>
                <div className="mt-8">
                  <a
                    href="mailto:tabaartist@gmail.com"
                    className="group inline-flex items-center gap-3 px-7 py-4 bg-[var(--clay)] text-[var(--bone)] rounded-full tracking-wide hover:bg-[var(--bone)] hover:text-[var(--ink)] transition-colors"
                  >
                    Write to us
                    <span className="relative w-4 h-4 overflow-hidden">
                      <span className="absolute inset-0 transition-transform duration-500 group-hover:translate-x-5 group-hover:-translate-y-5">
                        →
                      </span>
                      <span className="absolute inset-0 -translate-x-5 translate-y-5 transition-transform duration-500 group-hover:translate-x-0 group-hover:translate-y-0">
                        →
                      </span>
                    </span>
                  </a>
                </div>
              </div>
              <div className="col-span-12 md:col-span-5 md:pl-12 md:border-l md:border-[var(--line)] flex flex-col justify-center">
                <div className="font-display text-7xl md:text-9xl text-[var(--clay)] tabular-nums leading-none">
                  {String(teamData.length).padStart(2, "0")}
                </div>
                <div className="mt-3 text-[10px] uppercase tracking-[0.32em] text-[var(--muted)]">
                  Artists in the studio
                </div>
                <div className="mt-8 text-[var(--bone)] text-[15px] leading-relaxed">
                  Zaid, Vikas, Anurag, Irfan, Aakash, Abdul, Naveen, Sanjay,
                  Sourav — and counting.
                </div>
              </div>
            </div>
          </Reveal>
        </div>
      </section>
    </main>
  );
};

export default Team;